<template>
    <page
        id="dashboard"
        title="Dashboard"
        :status="page_status"
        :waiting="waiting"
        @statused="statused"
    >
        <template v-slot:title><span></span></template>
        <cards id="dashboard" :cards="cards" :selectable="false" :flex="true">
            <template slot="card" slot-scope="props">
                <workload-card v-if="props.card.id==='workload'" :card="props.card" />
                <projects-card v-if="props.card.id==='projects'" :card="props.card" :active="true" />
                <billing-schedule-card v-if="props.card.id==='billing_schedule'" :card="props.card" />
                <personal-card v-if="props.card.id==='user'" :card="props.card" />
                <time-off-card v-if="props.card.id==='time-off'" :card="props.card" />
                <time-off-requests-card v-if="props.card.id==='time-off-requests'" :card="props.card" />
                <out-of-office-card v-if="props.card.id==='out-of-office'" :card="props.card" />
                <completed-projects-card v-if="props.card.id==='completed-projects'" :card="props.card" />
                <bookmarks-card v-if="props.card.id==='bookmarks'" :card="props.card" />
                <tools-card v-if="props.card.id==='tools'" :card="props.card" />
            </template>
        </cards>
    </page>
</template>

<script type="text/javascript">
import is_page from "../../mixins/IsPage"
import profile_utilities from "../../mixins/ProfileUtilities"

import Cards from "../../ui/Cards"
import WorkloadCard from "./WorkloadCard"
import PersonalCard from "./PersonalCard"
import TimeOffCard from "./TimeOffCard"
import TimeOffRequestsCard from "./TimeOffRequestsCard"
import ProjectsCard from "./ProjectsCard"
import CompletedProjectsCard from "./CompletedProjectsCard"
import BookmarksCard from "./BookmarksCard"
import ToolsCard from "./ToolsCard"
import BillingScheduleCard from "./BillingScheduleCard"
import OutOfOfficeCard from "./OutOfOfficeCard"

export default {
    mixins: [is_page, profile_utilities],
    components: {
        Cards,
        WorkloadCard,
        PersonalCard,
        TimeOffCard,
        TimeOffRequestsCard,
        ProjectsCard,
        CompletedProjectsCard,
        BookmarksCard,
        ToolsCard,
        BillingScheduleCard,
        OutOfOfficeCard
    },
    computed: {
        cards () {
            const cards = []
            if(!this.is_business_manager && !this.is_administrator) {
                cards.push({
                    id: "workload",
                    entity: "project",
                    type: "Workload",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-1-1": true },
                    titleless: true
                })
            }

            if(!this.is_business_manager) {
                cards.push({
                    id: "projects",
                    entity: "project",
                    type: "Projects",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-1-1": true }
                })
            }

            /*
            if(!this.is_business_manager || this.is_administrator) {
                cards.push({
                    id: "engagement",
                    entity: "project",
                    type: "Engagement",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-1-1": true }
                })
            }

            if(!this.is_designer) {
                cards.push({
                    id: "prospective-projects",
                    entity: "project",
                    type: "Prospective Projects",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-1": true, "uk-width-xlarge-2-3": true }
                })
            }
            */

            cards.push({
                id: "out-of-office",
                entity: "user",
                type: "Team Out Of Office",
                record: this.profile,
                revisions_entity: null,
                classes: { "uk-width-1-1": true }
            })

            cards.push({
                id: "time-off",
                entity: "time_off_request",
                type: "Time Off",
                record: this.profile,
                revisions_entity: null,
                classes: { "uk-width-small-1-2": true, "uk-width-xlarge-1-3": true }
            })

            cards.push({
                id: "user",
                entity: "user",
                type: "Personal",
                record: this.profile,
                revisions_entity: null,
                classes: { "uk-width-small-1-2": true, "uk-width-xlarge-1-3": true }
            })

            if(this.profile && ((!!this.profile.arbiter_studio_ids && !!this.profile.arbiter_studio_ids.length) || this.profile.time_off_view)) {
                cards.push({
                    id: "time-off-requests",
                    entity: "time_off_request",
                    type: "Time Off Requests",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-2": true, "uk-width-xlarge-1-3": true }
                })
            }

            if(this.is_db_admin_active || !!window.nibnut.vue.application_settings.office_bookmarks) {
                cards.push({
                    id: "bookmarks",
                    entity: "settings",
                    type: "Bookmarks",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-2": true, "uk-width-xlarge-1-3": true }
                })
            }

            if(this.is_db_admin_active || this.is_administrator || this.is_developer) {
                cards.push({
                    id: "billing_schedule",
                    entity: "billing_schedule_month",
                    type: "Billing Schedule",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-2": true, "uk-width-xlarge-1-3": true }
                })
            }

            /*
            if(this.profile && this.profile.closeout_manager) {
                cards.push({
                    id: "closeout-projects",
                    entity: "project",
                    type: "Closeout Projects",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-1": true, "uk-width-xlarge-1-3": true }
                })
            }

            if(this.profile && !this.is_designer) {
                cards.push({
                    id: "completed-projects",
                    entity: "project",
                    type: "Completed Projects",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-1": true, "uk-width-xlarge-1-3": true }
                })
            }
            */

            if(this.is_db_admin_active || this.is_administrator || this.is_developer) {
                cards.push({
                    id: "tools",
                    entity: "tools",
                    type: "Tools",
                    record: this.profile,
                    revisions_entity: null,
                    classes: { "uk-width-small-1-2": true, "uk-width-xlarge-1-3": true }
                })
            }

            return cards
        }
    }
}
</script>
